<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> 
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div> 
              <div class="card-header">
                <img :src="item.image_1" alt="Content Image" class="image" />
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/007/InnovationEntrepreneurshipPageimg1.png"),
            title:
              "中东欧青年创新创业大赛在宁波成功举办——云翰虹章团队分享创业成果",
            description_no_1:``,
            description_1:`
              在2021年2月9日的中国-中东欧国家领导人峰会上，习近平主席就中国-中东欧关系提出了有关倡议，建议双方汇聚青年科技人才和创新创业者，推动中国与中东欧国家青年科技人才之间的交流与合作。为贯彻落实该倡议，中国科学技术部国际合作司、中国科学技术部外国专家服务司、浙江省科学技术厅、宁波市人民政府于2023年5月17日下午在宁波成功举办了首届中东欧国家青年创新创业大赛。

              次日上午，云翰虹章团队在宁波诺丁汉大学国际创新创业孵化园参加了一场创新创业交流研讨会。来自中国和中东欧的青年科技人才齐聚一堂，孵化园的创业代表和部分大赛获奖选手分别介绍了各自的创新创业项目。在本次研讨会上，云翰虹章团队作为孵化园的创业代表之一分享了其创业经历与科技成果。

              此次中东欧国家青年创新创业大赛及交流研讨活动的成功举办，为云翰虹章提供了展示创新成果与分享创业经验的宝贵平台。在这次研讨会上，我们与来自中国与中东欧国家的青年科技人才深入交流，收获了宝贵的反馈与建议。在未来，云翰虹章将继续致力于科技创新，推动全球科技创新发展。
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/007/InnovationEntrepreneurshipPageimg1.png"),
            title:
              "Central and Eastern Europe Youth Innovation and Entrepreneurship Competition was successfully held in Ningbo -- Rosy Nebula shared the entrepreneurial achievements",
            description_no_1:``,
            description_1:`
              In the China-CEEC Summit 2021, Chairman Xi brought forward an opinion about the China-CEEC relationship. He proposed that both sides should bring together young scientific and technological talents and innovative entrepreneurs to promote exchanges and cooperation between young scientific and technological talents from China and CEEC countries.

              To implement the initiative, on May 17, 2023, the Ministry of Science and Technology of the People’s Republic of China, the Department of Science and Technology of Zhejiang Province, The People’s Government of Ningbo Municipality successfully held The 1st China-CEEC Youth Innovation And Entrepreneurship Competition in Ningbo. 

              The following day, Rosy Nebula attended an Innovation and Entrepreneurship Exchange Seminar in International Innovation and Entrepreneurship Incubator at the University of Nottingham Ningbo. The seminar gathered young scientific and technological talents from China and Central and Eastern Europe. The representative of the incubator and part of the winners introduced their projects. As one of the representatives of the incubator, Rosy Nebula shared her venture development experience and scientific achievements.

              The successful competition and seminar hosting provided a platform for Rosy Nebula to share her experiences and achievements. In the seminar, we communicated with the participants from China and Central and Eastern Europe, got their feedback and advice. In the future, Rosy Nebula will continue to be committed to innovation. 
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  mixins: [],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
